module.exports = "<particles [params]=\"myParams\" [style]=\"myStyle\" [width]=\"width\" [height]=\"height\"></particles>\r\n\r\n<div class=\"borders\"></div>\r\n\r\n<app-menu-component><</app-menu-component>\r\n\r\n<div id=\"logo-container\">\r\n    <h1 id=\"logo\">the<span>bat</span>claud.<span>io</span></h1>\r\n</div>\r\n\r\n<content>\r\n    <router-outlet></router-outlet>\r\n</content>"


//////////////////
// WEBPACK FOOTER
// /home/claudio/Projects/thebatclaudio.github.io/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main